angular.module('account.settings', ['account', 'user-group'])
    .config(function ($stateProvider) {
        $stateProvider
            .state('accountSettings', {
                abstract: true,
                parent: 'app',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/account/settings/_settings.html'
                    }
                }
            })
            .state('accountSettingsMain', {
                parent: 'accountSettings',
                url: '/settings',
                views: {
                    'settings@^': 'accountSettingsProfileComponent'
                }
            })
            .state('accountSettingsPassword', {
                parent: 'accountSettings',
                url: '/settings/password-change',
                views: {
                    'settings@^': 'accountSettingsPasswordComponent'
                }
            })
            .state('accountSettingsLanguage', {
                parent: 'accountSettings',
                url: '/settings/language',
                views: {
                    'settings@^': 'accountSettingsLanguageComponent'
                }
            })
            .state('accountSettingsICal', {
                parent: 'accountSettings',
                url: '/settings/ical',
                views: {
                    'settings@^': 'accountSettingsICalComponent'
                }
            })
            .state('accountSettingsSharedCalendar', {
                parent: 'accountSettings',
                url: '/settings/shared-calendar',
                views: {
                    'settings@^': 'accountSettingsSharedCalendarComponent'
                }
            })
    })
